import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.features.lock-all-catalog-items`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Catalock has been updated successfully.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Something went wrong. Please try again.',
  },
})
